module.exports = __webpack_public_path__ + "img/xml.329452f2.png";